import React, { useEffect, useState } from 'react'
import ModalCustom from '../../../components/modal-custom'
import { Button, Col, Form } from 'react-bootstrap'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import * as yup from 'yup'
import LabelCustom from '../../../components/label-custom'
import AutocompleteCustom from '../../../components/custom/autocomplete'
import { BsExclamationCircle } from 'react-icons/bs'
import CustomDatePicker from '../../../components/custom/CustomDatePicker'
import { useDebounce } from '@react-hook/debounce'
import Error_false from '../../../components/error/error-false'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import {
  createIncomeCertificateAPI,
  deleteIncomeCertificateAPI,
  updateIncomeCertificateAPI
} from '../../../services/income/certficate'
import UseAllCertificate from '../../../hooks/use-certificate'
import InputPriceCustom from '../../../components/custom/InputPriceCustom'
import { fnDateEn } from '../../../helper/fnDateEn'
import UseSearchEmployeePayment from '../../../hooks/use-emps-payment'

const schema = yup
  .object({
    username: yup.object().required('Please choose your name.'),
    type: yup.object().required('Please choose your type.'),
    startDate: yup.string().required('Please choose your start date.'),
    endDate: yup.string().required('Please choose your end date.'),
    cerPeriodStart: yup.string().required('Please choose your end date.'),
    cerPeriodEnd: yup.string().required('Please choose your end date.'),
    amount: yup.string().required('Please choose your amount.')
  })
  .required()

export default function ModalUpdate({
  data,
  fnGetData,
  onCancel,
  open,
  orgId
}) {
  const {
    control,
    handleSubmit,
    reset,
    setValue,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [searchs, setSearchs] = useDebounce('', 1000)
  const empPVD = UseSearchEmployeePayment(orgId, searchs)
  const [endDate, setEndDate] = useState(null)
  const [startDate, setStartDate] = useState(null)
  const [periodStart, setPeriodStart] = useState(null)
  const [periodEnd, setPeriodEnd] = useState(null)
  const [isSubmit, setIsSubmit] = useState(false)

  const allCertificate = UseAllCertificate()
  useEffect(() => {
    if (data) {
      setValue('username', {
        personId: data.personId,
        code: data.code,
        value: data?.username,
        label: `${data?.org ?? ''} - ${data?.code ?? ''} - ${
          data?.nameEn ?? ''
        } `
      })
      setValue('type', {
        label: data.paymentNameCer,
        value: data.paymentNameCerId
      })
      setValue('amount', data.paymentCerAmounts)

      setValue('startDate', new Date(data.paymentCerStart))
      setValue('endDate', new Date(data.paymentCerExpires))
      setStartDate(new Date(data.paymentCerStart))
      setEndDate(new Date(data.paymentCerExpires))

      setValue('cerPeriodStart', new Date(data.cerPeriodStart))
      setValue('cerPeriodEnd', new Date(data.cerPeriodEnd))
      setPeriodStart(new Date(data.cerPeriodStart))
      setPeriodEnd(new Date(data.cerPeriodEnd))
    }
  }, [data, setValue])

  const onSubmit = async (d) => {
    const body = {
      orgId,
      code: d.username.code,
      personId: d.username.personId,
      paymentCerAmounts: d.amount?.replace(/,/g, ''),
      paymentCerStart: fnDateEn(d.startDate).format('YYYY-MM-DD'),
      paymentCerExpires: fnDateEn(d.endDate).format('YYYY-MM-DD'),
      cerPeriodStart: fnDateEn(d.cerPeriodStart).format('YYYY-MM-DD'),
      cerPeriodEnd: fnDateEn(d.cerPeriodEnd).format('YYYY-MM-DD')
    }
    if (data) {
      sendAPI(
        updateIncomeCertificateAPI({
          paymentCerId: data.paymentCerId,
          ...body
        })
      )
    } else {
      sendAPI(
        createIncomeCertificateAPI({ ...body, paymentNameCerId: d.type.value })
      )
    }
  }

  const fnDelete = () => {
    SwalCustom({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'error',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!'
    }).then(async (result) => {
      if (result.isConfirmed) {
        let body = {
          orgId,
          code: data.code,
          personId: data.personId,
          paymentCerId: data.paymentCerId
        }
        sendAPI(deleteIncomeCertificateAPI(body))
      }
    })
  }

  const sendAPI = async (api) => {
    setIsSubmit(true)
    const resp = await api
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        onCancel()
        fnGetData()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>{data ? 'Update' : 'Add'} </h5>
      </div>
      <Form className="row g-3" onSubmit={handleSubmit(onSubmit)}>
        <Col xl={12}>
          <LabelCustom text={'Employee'} />
          <Controller
            name={'username'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <AutocompleteCustom
                options={empPVD}
                value={value}
                onChange={(e) => {
                  onChange(e)
                }}
                onInputChange={(data) => {
                  setSearchs(data)
                }}
              />
            )}
          />
          {errors.username && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.username.message}
            </span>
          )}
        </Col>
        <Col xl={12}>
          <LabelCustom text={'Certificate'} />
          <Controller
            name={'type'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <AutocompleteCustom
                options={allCertificate}
                value={value}
                onChange={(d) => {
                  setValue('amount', d.paymentCerAmounts)
                  onChange(d)
                }}
              />
            )}
          />
          {errors.type && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.type.message}
            </span>
          )}
        </Col>

        <Col xl={6}>
          <LabelCustom text={'Cert Start Date'} />
          <Controller
            name={'startDate'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <CustomDatePicker
                isClearable={true}
                value={value}
                maxDate={endDate}
                onChange={(d) => {
                  setStartDate(d)
                  onChange(d)
                }}
                showYearDropdown
                showMonthDropdown
              />
            )}
          />
          {errors.startDate && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.startDate.message}
            </span>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text={'Cert Expiration Date'} />
          <Controller
            name={'endDate'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <CustomDatePicker
                isClearable={true}
                value={value}
                minDate={startDate}
                onChange={(d) => {
                  setEndDate(d)
                  onChange(d)
                }}
                showYearDropdown
                showMonthDropdown
              />
            )}
          />
          {errors.endDate && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.endDate.message}
            </span>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text={'Periods Start Date'} />
          <Controller
            name={'cerPeriodStart'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <CustomDatePicker
                isClearable={true}
                value={value}
                maxDate={periodEnd}
                onChange={(d) => {
                  setPeriodStart(d)
                  onChange(d)
                }}
                showYearDropdown
                showMonthDropdown
              />
            )}
          />
          {errors.cerPeriodStart && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.cerPeriodStart.message}
            </span>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text={'Periods End Date'} />
          <Controller
            name={'cerPeriodEnd'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <CustomDatePicker
                isClearable={true}
                value={value}
                minDate={periodStart}
                onChange={(d) => {
                  setPeriodEnd(d)
                  onChange(d)
                }}
                showYearDropdown
                showMonthDropdown
              />
            )}
          />
          {errors.cerPeriodEnd && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.cerPeriodEnd.message}
            </span>
          )}
        </Col>
        <Col xl={12}>
          <LabelCustom text={'Amount'} />
          <Controller
            name={'amount'}
            control={control}
            render={({ field: { onChange, value = null } }) => (
              <InputPriceCustom value={value} onChange={onChange} />
            )}
          />
          {errors.amount && (
            <span className="text-danger small fw-light">
              <BsExclamationCircle /> {errors.amount.message}
            </span>
          )}
        </Col>

        <Col xl={12} className="d-flex justify-content-center g-3 gap-3 mt-4">
          <Button onClick={onCancel} variant="light" className="px-4">
            Close
          </Button>
          {data && (
            <Button variant="danger" className="px-4" onClick={fnDelete}>
              Delete
            </Button>
          )}

          <Button disabled={isSubmit} type="submit" className="px-4">
            Submit{isSubmit && '...'}
          </Button>
        </Col>
      </Form>
    </ModalCustom>
  )
}
